import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

/** Paginação, busca e ordenação na URL (nuqs). Filtros de domínio ficam em useQueryStates próprios. */
export function useTableParams(defaults: { sort?: string; order?: 'asc' | 'desc'; pageSize?: number } = {}) {
  const [state, set] = useQueryStates(
    {
      page: parseAsInteger.withDefault(1),
      pageSize: parseAsInteger.withDefault(defaults.pageSize ?? 20),
      q: parseAsString.withDefault(''),
      sort: parseAsString.withDefault(defaults.sort ?? ''),
      order: parseAsStringLiteral(['asc', 'desc'] as const).withDefault(defaults.order ?? 'asc'),
    },
    { history: 'replace' },
  );
  return {
    ...state,
    set,
    query: { page: state.page, pageSize: state.pageSize, q: state.q || undefined, sort: state.sort || undefined, order: state.order },
    setSearch: (q: string) => set({ q, page: 1 }),
    toggleSort: (col: string) =>
      set({ sort: col, order: state.sort === col && state.order === 'asc' ? 'desc' : 'asc', page: 1 }),
  };
}
export type TableParams = ReturnType<typeof useTableParams>;
